import { render, staticRenderFns } from "./add_coupon.vue?vue&type=template&id=96ef9f26&scoped=true"
import script from "./add_coupon.vue?vue&type=script&lang=js"
export * from "./add_coupon.vue?vue&type=script&lang=js"
import style0 from "./add_coupon.vue?vue&type=style&index=0&id=96ef9f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ef9f26",
  null
  
)

export default component.exports